import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/Home/home'
//创建应用
import CreateApp from '@/pages/CreateApp/create-app'
import Param from '@/pages/CreateApp/param'
import Pay from '@/pages/CreateApp/pay'
import Page from '@/pages/CreateApp/page'
import Authorize from '@/pages/CreateApp/authorize'
import Station from '@/pages/CreateApp/station'
import Records from '@/pages/CreateApp/records'
import BeforeStation from '@/pages/CreateApp/before-station'
//import Guide from '@/pages/CreateApp/guide'

import NotFound from '@/pages/NotFound/not-found'

//登陆注册
import LoginTpl from '@/pages/Login/login-tpl'
import Login from '@/pages/Login/login'
import Phone from '@/pages/Login/phone'
import resetPw from '@/pages/Login/resetPw'
import findPw from '@/pages/Login/findPw'
import findPwBe from '@/pages/Login/findPwBe'
import Registe from '@/pages/Registe/registe'

import Protocol from '@/pages/Registe/protocol'


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },{
      path: '/login',
      component: LoginTpl,
      children: [
        {path: '/', name: 'Login', component: Login},
        {path: 'phone', name: 'Phone', component: Phone},
        {path: 'resetPw',name: 'resetPw', component: resetPw},
        {path: 'findPw',name: 'findPw', component: findPw},
        {path: 'findPwBe',name: 'findPwBe', component: findPwBe}
      ]
    },{
      path: '/registe',
      name: 'Registe',
      component: Registe
    },{
      path: '/protocol',
      name: 'Protocol',
      component: Protocol
    },{
      path: '/create-app/:id',
      component: CreateApp,
      redirect: 'create-app/:id/param',
      children: [
        {path: 'param', component: Param},
        {path: 'page', component: Page},
        {path: 'pay', component: Pay},
        {path: 'authorize',component: Authorize},
        {path: 'station', component: Station},
        {path: 'records', component: Records},
        {path: 'before-station', component: BeforeStation}
        //{path: 'guide',component: Guide}
      ]
    },{
      path: '*',
      name: '404',
      component: NotFound
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js